import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number", 
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_NUMBER: "array_number",
    ARRAY_STRING: "array_string",
    ARRAY_DATE: "array_date",
    ARRAY_OBJECT: "array_objectId",
    ARRAY_BOOLEAN: "array_boolean",
    OBJECT: "object",
    MIXED: "mixed",
};

const contexts = {
    CONTACT: "contact",
    CONVERSATION: "conversation",
    BLOCK: "block",
    EVENT: "event",
    WEBHOOK: "webhook",
    SYSTEM: "system",
    CUSTOM: "custom",
};

const defaultOperators = {
    string: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
    ],
    array: ["equal", "not_equal", "contains", "not_contains", "empty", "not_empty"],
    number: ["equal", "not_equal", "greater_than", "less_than", "greater_than_or_equal", "less_than_or_equal"],
    boolean: ["equal", "not_equal", "empty", "not_empty"],
    date: [
        "equal",
        "not_equal",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
        "empty",
        "not_empty",
    ],
    ObjectId: ["equal", "not_equal", "empty", "not_empty"],
    object: ["equal", "not_equal", "empty", "not_empty"],
    mixed: [
        "equal",
        "not_equal",
        "contains",
        "not_contains",
        "empty",
        "not_empty",
        "starts_with",
        "ends_with",
        "shorter_than",
        "longer_than",
        "greater_than",
        "less_than",
        "greater_than_or_equal",
        "less_than_or_equal",
    ],
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        name,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || defaultOperators[valueType] || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class GooglePlayModuleAttributeFactory {
    /**
     * @param parent {AutomationAttributesGenerator}
     */
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.reviewReceived()
        );
    }

    reviewReceived() {
        const e = AutomationEventTypes.GOOGLE_PLAY.REVIEW_RECEIVED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Google Play Review Received", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}._id`, "Review Record ID", vt.STRING),
                ga(context, `${prefix}.reviewId`, "Review ID", vt.STRING),
                ga(context, `${prefix}.packageName`, "Package Name", vt.STRING),
                ga(context, `${prefix}.channelId`, "Channel ID", vt.STRING),
                ga(context, `${prefix}.authorName`, "Author Name", vt.STRING),
                ga(context, `${prefix}.starRating`, "Star Rating", vt.NUMBER),
                ga(context, `${prefix}.comment`, "Comment", vt.STRING),
                ga(context, `${prefix}.reviewerLanguage`, "Reviewer Language", vt.STRING),
                ga(context, `${prefix}.createTime`, "Create Time", vt.DATETIME),
                ga(context, `${prefix}.updateTime`, "Update Time", vt.DATETIME),
                ga(context, `${prefix}.status`, "Status", vt.STRING),
                ga(context, `${prefix}.device`, "Device", vt.STRING),
                ga(context, `${prefix}.androidOsVersion`, "Android OS Version", vt.NUMBER),
                ga(context, `${prefix}.appVersionCode`, "App Version Code", vt.NUMBER),
                ga(context, `${prefix}.appVersionName`, "App Version Name", vt.STRING),
                ga(context, `${prefix}.thumbsUpCount`, "Thumbs Up Count", vt.NUMBER),
                ga(context, `${prefix}.thumbsDownCount`, "Thumbs Down Count", vt.NUMBER),
                ga(context, `${prefix}.deviceMetadata`, "Device Metadata", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.deviceMetadata.productName`, "Product Name", vt.STRING),
                    ga(context, `${prefix}.deviceMetadata.manufacturer`, "Manufacturer", vt.STRING),
                    ga(context, `${prefix}.deviceMetadata.deviceClass`, "Device Class", vt.STRING),
                    ga(context, `${prefix}.deviceMetadata.screenWidthPx`, "Screen Width (px)", vt.NUMBER),
                    ga(context, `${prefix}.deviceMetadata.screenHeightPx`, "Screen Height (px)", vt.NUMBER),
                    ga(context, `${prefix}.deviceMetadata.nativePlatform`, "Native Platform", vt.STRING),
                    ga(context, `${prefix}.deviceMetadata.screenDensityDpi`, "Screen Density (DPI)", vt.NUMBER),
                    ga(context, `${prefix}.deviceMetadata.ramMb`, "RAM (MB)", vt.NUMBER),
                ]),
                ga(context, `${prefix}.reply`, "Reply Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.reply.text`, "Reply Text", vt.STRING),
                    ga(context, `${prefix}.reply.lastModified`, "Reply Time", vt.DATETIME),
                ]),
                ga(context, `${prefix}.app`, "App Info", vt.OBJECT, undefined, [
                    ga(context, `${prefix}.app._id`, "App Record ID", vt.STRING),
                    ga(context, `${prefix}.app.packageName`, "Package Name", vt.STRING),
                    ga(context, `${prefix}.app.appName`, "App Name", vt.STRING),
                    ga(context, `${prefix}.app.iconUrl`, "Icon URL", vt.STRING),
                    ga(context, `${prefix}.app.totalReviewCount`, "Total Review Count", vt.NUMBER),
                    ga(context, `${prefix}.app.averageRating`, "Average Rating", vt.NUMBER),
                ]),
            ])
        ];
    }
}

export default GooglePlayModuleAttributeFactory;
